// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"d4373bb1","227":"390c4650","453":"2c88876b","648":"06c3fdc9","961":"de79f15e"}[chunkId] + ".chunk.js";
};